document.documentElement.classList.add('js');

document.addEventListener('DOMContentLoaded', () => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const storeCurrency = document.body.dataset.currency || 'EUR';
  const storeLocale = document.documentElement.lang || 'en';
  const moneyFormatter = new Intl.NumberFormat(storeLocale, { style: 'currency', currency: storeCurrency });
  document.querySelectorAll('[data-money-price]').forEach((price) => {
    const cents = Number(price.dataset.moneyPrice || 0);
    if (Number.isFinite(cents)) price.textContent = moneyFormatter.format(cents / 100);
  });
  const trackConversion = (event, details = {}) => {
    if (!Array.isArray(window.dataLayer)) window.dataLayer = [];
    window.dataLayer.push({ event, ...details });
    document.dispatchEvent(new CustomEvent('wote:conversion', { detail: { event, ...details } }));
  };
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a');
    if (!link) return;
    if (link.matches('.category-card')) trackConversion('category_selected', { category: link.querySelector('strong')?.textContent?.trim() || '', destination: link.pathname });
    if (link.href.includes('ig.me/m/whispersoftheeast')) trackConversion('instagram_contact_clicked', { location: link.closest('section,header,footer,aside')?.id || link.closest('section,header,footer,aside')?.className || 'site' });
    if (link.protocol === 'mailto:') trackConversion('email_contact_clicked', { location: link.closest('section,header,footer,aside')?.id || link.closest('section,header,footer,aside')?.className || 'site' });
  });

  document.querySelectorAll('[data-category-toggle]').forEach((button) => {
    const grid = button.closest('.page-width')?.querySelector('.category-grid:not(.category-grid--secondary)');
    if (!grid) return;
    button.addEventListener('click', () => {
      const expanded = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!expanded));
      grid.classList.toggle('is-expanded', !expanded);
      button.querySelector('span').textContent = expanded ? 'View all 11 spell themes' : 'Show fewer spell themes';
      trackConversion(expanded ? 'spell_themes_collapsed' : 'spell_themes_expanded');
    });
  });

  document.querySelectorAll('[data-depth-choice]').forEach((link) => link.addEventListener('click', () => {
    window.sessionStorage.setItem('woteDepth', link.dataset.depthChoice);
    trackConversion('depth_guide_selected', { depth: link.dataset.depthChoice });
  }));
  document.querySelectorAll('.category-card[href*="/products/"]').forEach((link) => link.addEventListener('click', () => {
    const savedDepth = window.sessionStorage.getItem('woteDepth');
    if (!savedDepth) return;
    const destination = new URL(link.href, window.location.origin);
    destination.searchParams.set('depth', savedDepth);
    link.href = destination.toString();
  }));
  const revealElements = [...document.querySelectorAll('.category-card, .tier, .step, .client-feedback__layout > *, .product-layout > *, .included-grid > *, .cart-item, .confidence-strip article')];
  if (reduceMotion) {
    revealElements.forEach((element) => element.classList.add('is-visible'));
  } else if ('IntersectionObserver' in window) {
    revealElements.forEach((element, index) => {
      element.classList.add('motion-reveal');
      element.style.setProperty('--reveal-delay', `${Math.min(index % 4, 3) * 55}ms`);
    });
    document.documentElement.classList.add('motion-ready');
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -7% 0px', threshold: 0.08 });
    revealElements.forEach((element) => revealObserver.observe(element));
  }

  const ticker = document.querySelector('[data-trust-ticker]');
  if (ticker) {
    const messages = [...ticker.querySelectorAll('[data-trust-message]')];
    const previous = ticker.querySelector('[data-trust-prev]');
    const next = ticker.querySelector('[data-trust-next]');
    let active = 0;
    let timer;

    const showMessage = (index) => {
      active = (index + messages.length) % messages.length;
      messages.forEach((message, messageIndex) => {
        message.hidden = messageIndex !== active;
        message.classList.toggle('is-active', messageIndex === active);
      });
    };
    const stopRotation = () => window.clearInterval(timer);
    const startRotation = () => {
      stopRotation();
      if (!reduceMotion && messages.length > 1) timer = window.setInterval(() => showMessage(active + 1), 5200);
    };

    previous?.addEventListener('click', () => { showMessage(active - 1); startRotation(); });
    next?.addEventListener('click', () => { showMessage(active + 1); startRotation(); });
    ticker.addEventListener('pointerenter', stopRotation);
    ticker.addEventListener('pointerleave', startRotation);
    ticker.addEventListener('focusin', stopRotation);
    ticker.addEventListener('focusout', startRotation);
    showMessage(0);
    startRotation();
  }

  document.querySelectorAll('[data-feedback-track]').forEach((track) => {
    const section = track.closest('.client-feedback__highlights');
    const previous = section?.querySelector('[data-feedback-prev]');
    const next = section?.querySelector('[data-feedback-next]');
    const status = section?.querySelector('[data-feedback-status]');
    const cards = [...track.querySelectorAll('[data-feedback-card]')];
    if (!cards.length) return;
    let active = 0;
    let timer;
    let scrollFrame;
    const updateStatus = () => {
      if (status) status.textContent = `${active + 1} / ${cards.length}`;
      cards.forEach((card, index) => card.toggleAttribute('data-current', index === active));
    };
    const goTo = (index) => {
      active = (index + cards.length) % cards.length;
      const left = cards[active].offsetLeft - cards[0].offsetLeft;
      track.scrollTo({ left, behavior: reduceMotion ? 'auto' : 'smooth' });
      updateStatus();
    };
    const syncFromScroll = () => {
      const nearest = cards.reduce((best, card, index) => {
        const distance = Math.abs(track.scrollLeft - (card.offsetLeft - cards[0].offsetLeft));
        return distance < best.distance ? { index, distance } : best;
      }, { index: active, distance: Infinity });
      active = nearest.index;
      updateStatus();
    };
    const stop = () => window.clearInterval(timer);
    const start = () => {
      stop();
      if (!reduceMotion && document.visibilityState === 'visible') timer = window.setInterval(() => goTo(active + 1), 7000);
    };
    previous?.addEventListener('click', () => { goTo(active - 1); start(); });
    next?.addEventListener('click', () => { goTo(active + 1); start(); });
    track.addEventListener('scroll', () => {
      window.cancelAnimationFrame(scrollFrame);
      scrollFrame = window.requestAnimationFrame(syncFromScroll);
    }, { passive: true });
    track.addEventListener('pointerenter', stop);
    track.addEventListener('pointerleave', start);
    track.addEventListener('focusin', stop);
    track.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
    updateStatus();
    start();
  });
  document.querySelectorAll('.review-library').forEach((library) => library.addEventListener('toggle', () => {
    if (library.open) trackConversion('additional_reviews_opened');
  }));

  const toggle = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
      document.body.classList.toggle('menu-open', !open);
    });
    menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => {
      toggle.setAttribute('aria-expanded', 'false');
      menu.hidden = true;
      document.body.classList.remove('menu-open');
    }));
  }

  document.querySelectorAll('.product-gallery').forEach((gallery) => {
    const mainImage = gallery.querySelector('.product-gallery__main img');
    const thumbnails = [...gallery.querySelectorAll('[data-gallery-src]')];
    if (!mainImage || !thumbnails.length) return;
    thumbnails.forEach((thumbnail) => thumbnail.addEventListener('click', () => {
      mainImage.src = thumbnail.dataset.gallerySrc;
      mainImage.removeAttribute('srcset');
      mainImage.alt = thumbnail.dataset.galleryAlt || mainImage.alt;
      thumbnails.forEach((item) => item.classList.toggle('is-active', item === thumbnail));
    }));
  });

  document.querySelectorAll('[data-personalized-form]').forEach((wrapper) => {
    const form = wrapper.querySelector('form');
    const booster = wrapper.querySelector('[data-booster]');
    const total = wrapper.querySelector('[data-order-total]');
    const button = wrapper.querySelector('[data-order-button]');
    const error = wrapper.querySelector('[data-order-error]');
    const currency = wrapper.dataset.currency || 'EUR';
    const boosterPrice = Number(wrapper.dataset.boosterPrice || 0);
    const flowSteps = [...wrapper.querySelectorAll('[data-flow-step]')];
    const flowNavigation = [...wrapper.querySelectorAll('[data-flow-nav]')];
    let currentFlow = Number(flowSteps.find((step) => step.classList.contains('is-active'))?.dataset.flowStep || flowSteps[0]?.dataset.flowStep || 1);
    let highestFlow = currentFlow;

    const showFlowStep = (stepNumber, shouldScroll = true) => {
      if (!flowSteps.length) return;
      currentFlow = stepNumber;
      flowSteps.forEach((step) => step.classList.toggle('is-active', Number(step.dataset.flowStep) === stepNumber));
      flowNavigation.forEach((item) => {
        const itemStep = Number(item.dataset.flowNav);
        item.classList.toggle('is-active', itemStep === stepNumber);
        item.classList.toggle('is-complete', itemStep < stepNumber);
        item.disabled = itemStep > highestFlow;
      });
      wrapper.classList.toggle('flow-at-final', stepNumber === 3);
      if (shouldScroll) wrapper.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      trackConversion('personalization_step_viewed', { product: wrapper.dataset.productHandle || '', step: stepNumber });
    };
    wrapper.querySelectorAll('[data-personalization-next]').forEach((button) => button.addEventListener('click', () => {
      const currentStep = wrapper.querySelector(`[data-flow-step="${currentFlow}"]`);
      const invalid = [...(currentStep?.querySelectorAll('input, textarea, select') || [])].find((field) => !field.checkValidity());
      if (invalid) {
        invalid.reportValidity();
        return;
      }
      const nextStep = Number(button.dataset.personalizationNext);
      highestFlow = Math.max(highestFlow, nextStep);
      showFlowStep(nextStep);
    }));
    flowNavigation.forEach((button) => button.addEventListener('click', () => {
      const destination = Number(button.dataset.flowNav);
      if (destination <= highestFlow) showFlowStep(destination);
    }));

    const selectedPrice = () => {
      const chosen = form?.querySelector('[name="id"]:checked') || form?.querySelector('[name="id"]');
      return Number(chosen?.dataset.variantPrice || 0);
    };
    const updateTotal = () => {
      if (!total) return;
      const cents = selectedPrice() + (booster?.checked ? boosterPrice : 0);
      total.textContent = new Intl.NumberFormat('en', { style: 'currency', currency }).format(cents / 100);
    };
    wrapper.querySelectorAll('[name="id"], [data-booster]').forEach((input) => input.addEventListener('change', () => {
      updateTotal();
      if (input.matches('input[type="radio"][name="id"]') && input.checked) trackConversion('product_depth_selected', { product: wrapper.dataset.productHandle || '', variant: input.dataset.variantTitle || '', price: Number(input.dataset.variantPrice || 0) / 100 });
      if (input.matches('[data-booster]')) trackConversion('booster_toggled', { product: wrapper.dataset.productHandle || '', selected: input.checked });
      if (!input.matches('input[type="radio"][name="id"]') || !input.checked) return;

      const url = new URL(window.location.href);
      url.searchParams.set('variant', input.value);
      window.history.replaceState({}, '', url);

      if (!input.dataset.variantImage) return;
      const gallery = wrapper.closest('.product-layout')?.querySelector('.product-gallery');
      const mainImage = gallery?.querySelector('.product-gallery__main img');
      if (!mainImage) return;
      mainImage.src = input.dataset.variantImage;
      mainImage.removeAttribute('srcset');
      mainImage.alt = input.dataset.variantTitle || mainImage.alt;
      gallery.querySelectorAll('.product-gallery__thumb').forEach((thumbnail) => {
        thumbnail.classList.toggle('is-active', thumbnail.dataset.gallerySrc === input.dataset.variantImage);
      });
    }));
    wrapper.querySelectorAll('[data-file-input]').forEach((input) => {
      const name = input.closest('.file-field')?.querySelector('[data-file-name]');
      input.addEventListener('change', () => {
        if (name) name.textContent = input.files?.[0]?.name || 'No file selected';
      });
    });
    const requestedDepth = Number(new URL(window.location.href).searchParams.get('depth') || window.sessionStorage.getItem('woteDepth') || 0);
    if (!new URL(window.location.href).searchParams.has('variant') && requestedDepth > 0) {
      const depthInput = wrapper.querySelectorAll('input[type="radio"][name="id"]')[requestedDepth - 1];
      if (depthInput && !depthInput.disabled) {
        depthInput.checked = true;
        depthInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      window.sessionStorage.removeItem('woteDepth');
    }
    updateTotal();
    if (flowSteps.length) showFlowStep(currentFlow, false);

    form?.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!form.reportValidity()) return;
      trackConversion('personalized_order_submitted', { product: wrapper.dataset.productHandle || '', variant: form.querySelector('[name="id"]:checked')?.dataset.variantTitle || '', booster: Boolean(booster?.checked) });
      const originalText = button?.textContent || '';
      if (button) {
        button.disabled = true;
        button.textContent = 'Adding your order...';
      }
      error?.classList.remove('is-visible');
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        if (!response.ok) {
          const problem = await response.json().catch(() => ({}));
          throw new Error(problem.description || 'This order could not be added.');
        }
        if (booster?.checked) {
          const boosterResponse = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(booster.value), quantity: 1, properties: { _Bundle: 'Personalized ritual booster' } }] })
          });
          if (!boosterResponse.ok) throw new Error('The ritual was added, but the booster is currently unavailable.');
          window.location.href = `${window.Shopify.routes.root}discount/RITUALBOOST35?redirect=${encodeURIComponent(`${window.Shopify.routes.root}cart`)}`;
          return;
        }
        window.location.href = `${window.Shopify.routes.root}cart`;
      } catch (problem) {
        if (error) {
          error.textContent = problem.message || 'Please try again or message me on Instagram.';
          error.classList.add('is-visible');
        }
        if (button) {
          button.disabled = false;
          button.textContent = originalText;
        }
      }
    });
  });
});
